import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	left: 60px;
	top: 140px;
	z-index: 5;
	width: 440px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 30px;

	transition: opacity 0.3s;
	opacity: 0;

	&.color-select-enter {
		opacity: 0;
	}

	&.color-select-enter-active,
	&.color-select-enter-done,
	&.color-select-exit {
		opacity: 1;
	}

	&.color-select-exit-active {
		opacity: 0;
	}
`;

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledSelectContainer = styled.div<{ $grid?: boolean }>`
	display: grid;
	grid-template-columns: ${(props) => (props.$grid ? '1fr 1fr' : '1fr')};
	gap: 10px;
`;

const StyledPaintingWheelsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledPainingWheelsInfoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

const StyledPaintingWheelsColorsGridWrapper = styled.div`
	position: relative;
	overflow: hidden;
`;

const StyledPaintingWheelsColorsGridMaskViewport = styled.div<{
	$leftFade: boolean;
}>`
	position: relative;
	overflow: hidden;
	width: 100%;

	@property --leftFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	--leftFade: ${({ $leftFade }) => ($leftFade ? '200px' : '0px')};

	-webkit-mask-image: linear-gradient(
		to right,
		transparent 0,
		black var(--leftFade),
		black 100%
	);
	mask-image: linear-gradient(
		to right,
		transparent 0,
		black var(--leftFade),
		black 100%
	);
	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;
	-webkit-mask-size: 100% 100%;
	mask-size: 100% 100%;
	transition: --leftFade 300ms ease;
`;

const StyledPaintingWheelsColorsGridFadeRight = styled.div<{
	$visible: boolean;
}>`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 100px;
	pointer-events: none;
	z-index: 1;
	background: linear-gradient(270deg, #111314 20%, rgba(17, 19, 20, 0) 100%);
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transition: opacity 0.3s ease;
`;

const StyledPaintingWheelsColorsGridTrack = styled.div`
	width: max-content;
	transition: transform 0.3s ease;
`;

const StyledPaintingWheelsColorsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(14, 20px);
	gap: 15px;
`;

const StyledGridButton = styled.div<{ $visible?: boolean }>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	cursor: pointer;
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
	transition:
		opacity 0.3s ease,
		background-color 0.3s ease;
	&:hover {
		background-color: #ffffff;

		.img-icon {
			background-color: #000000;
		}
	}

	.img-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #ffffff;
		transition: background-color 0.3s ease;
	}
`;

export {
	StyledContainer,
	StyledGridButton,
	StyledPainingWheelsInfoContainer,
	StyledPaintingWheelsColorsGrid,
	StyledPaintingWheelsColorsGridFadeRight,
	StyledPaintingWheelsColorsGridMaskViewport,
	StyledPaintingWheelsColorsGridTrack,
	StyledPaintingWheelsColorsGridWrapper,
	StyledPaintingWheelsContainer,
	StyledSelectContainer,
	StyledSettingsContainer,
};
